import { Box, Grid, Hidden, Typography, useMediaQuery, Popover, IconButton } from "@mui/material";
import React, { useState } from "react";

import HomeIcon from '@mui/icons-material/Home';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import ProductFilter from "../components/all_products_components/ProductFilter";
import ProductList from "../components/all_products_components/ProductList";
import theme from '../utils/theme.jsx';
import ApiService from "../api_service/api_service";

const AllProducts = () => {

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Box sx={{
            px: isSmallScreen ? '20px' : '100px',
            pb: '70px'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: '10px'
            }}>
                <Box sx={{
                    display: 'flex',
                }}>
                    <HomeIcon />
                    <Box width='5px' />
                    <KeyboardDoubleArrowRightIcon />
                    <Box width='5px' />
                    <Typography>All Products</Typography>
                </Box>
                <Hidden mdUp>
                    <IconButton
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Hidden>
            </Box>
            <Hidden mdDown>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <ProductFilter />
                    </Grid>
                    <Grid item xs={9}>
                        <ProductList />
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden mdUp>
                <ProductList />
            </Hidden>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: { width: '250px' }
                }}
            >
                {open && (
                    <ProductFilter />
                )}
            </Popover>
        </Box>
    )
}

export default AllProducts